/* ============================================================================
   LA HUELLA DE UN REGISTRO

   ═══ PARA QUÉ ═══

   El motor necesita saber si un registro local cambió desde la última vez que
   lo vio. Comparar objetos con `===` no sirve: cada edición crea uno nuevo.
   Comparar `JSON.stringify` tampoco: el orden de las claves cambia según quién
   armó el objeto, y dos registros iguales darían huellas distintas. El
   resultado sería una cola que crece con cambios que no cambiaron nada.

   Se serializa con las claves ordenadas y se hashea con FNV-1a. No es
   criptográfico y no hace falta que lo sea: detecta ediciones, no autentica.
   ========================================================================== */

/** Serialización estable: claves ordenadas, sin las que empiezan con `_`. */
export function serializarEstable(valor, visto = new WeakSet()) {
    if (valor === null || valor === undefined) return "null";
    if (typeof valor === "number") return Number.isFinite(valor) ? String(valor) : "null";
    if (typeof valor === "boolean" || typeof valor === "string") return JSON.stringify(valor);
    if (typeof valor !== "object") return "null";

    if (visto.has(valor)) return '"<ciclo>"';
    visto.add(valor);

    if (Array.isArray(valor)) {
        return `[${valor.map((v) => serializarEstable(v, visto)).join(",")}]`;
    }

    const claves = Object.keys(valor)
        .filter((k) => !k.startsWith("_"))
        .sort();
    return `{${claves.map((k) => `${JSON.stringify(k)}:${serializarEstable(valor[k], visto)}`).join(",")}}`;
}

/** Un entero de 32 bits en base 36. Estable entre ejecuciones. */
export function huella(valor) {
    const texto = serializarEstable(valor);
    let h = 0x811c9dc5;
    for (let i = 0; i < texto.length; i += 1) {
        h ^= texto.charCodeAt(i);
        h = Math.imul(h, 0x01000193);
    }
    return (h >>> 0).toString(36);
}
